import Paper from '@mui/material/Paper'

function LeadLiaisonBox({ children }: { children: JSX.Element | JSX.Element[] }): JSX.Element {
  return (
    <Paper
      sx={{
        maxWidth: 680,
        boxShadow: 1,
        borderRadius: 2,
        margin: 1,
      }}
    >
      {children}
    </Paper>
  )
}

export default LeadLiaisonBox
